import { ReactElement } from 'react';
import { IsLoginChecker } from '../../common/checkers/IsLoginChecker';
import { TrackPageViewContainer } from '../../common/containers/TrackPageViewContainer';
import { t } from '../../common/getTranslations';
import { Layout } from '../../design-system/layout/Layout';
import { WelcomeContainer } from '../../domain/welcome/container/WelcomeContainer';
import { WelcomeFetcher } from '../../domain/welcome/headless/WelcomeFetcher';
import { CommonMobileHeaderType } from '../../header/constants';
function Welcome() {
  return <div className="relative flex w-full grow flex-col items-center">
      <TrackPageViewContainer trackObj={{
      section: '웰컴페이지',
      page: '웰컴페이지',
      actionType: 'Pageview',
      actionName: '웰컴페이지_화면',
      customProps: {
        user_action: 'pv'
      }
    }} customPropsDataKeyList={[]} />
      <IsLoginChecker>
        <WelcomeFetcher>
          <WelcomeContainer />
        </WelcomeFetcher>
      </IsLoginChecker>
    </div>;
}
Welcome.getLayout = function getLayout(page: ReactElement) {
  return <Layout title={t('welcome_popup_webview_title')} mobileLayoutConfig={{
    shouldShowHeader: true,
    headerType: CommonMobileHeaderType.FourDepth
  }} pcLayoutConfig={{
    shouldShowHeader: true,
    shouldShowFooter: false,
    shouldUseFixedWidth: false
  }}>
      {page}
    </Layout>;
};
export default Welcome;